import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import PlanningRow from './PlanningRow'
import { AIRCRAFT_COLLECTION, AVAILABILITY_COLLECTION, BOOKING_COLLECTION } from '../../_constants/globals'
import { format, startOfDay } from 'date-fns'
import Loading from '../_library/Loading'
import { chain } from 'lodash'
import { Box } from '@mui/material'
import { useFirestore } from '../../hooks/useFirestore'
import PseudoBorderLine from './PseudoBorderLine'


const hoursStyle = {
  textAlign: 'center',
  fontSize: '11px',
  color: '#777',
}

const PlanningTable = ({ day }) => {
  
  const aircraftHooks = useFirestore(AIRCRAFT_COLLECTION)
  const dbAircrafts = aircraftHooks.getDocs()
  const bookingHooks = useFirestore(BOOKING_COLLECTION, { storeAs: 'PlanningTable' })
  const dbBookings = bookingHooks.getDocs()
  const availabilityHooks = useFirestore(AVAILABILITY_COLLECTION, { storeAs: 'dailyAvailabilities' })
  const dailyAvailabilities = availabilityHooks.getDocs()

  const aircrafts = useMemo(() => dbAircrafts?.filter(a => a.activated), [dbAircrafts])
  const instructors = dailyAvailabilities && chain(dailyAvailabilities).groupBy('userRef.id').toPairs().value()
  
  useEffect(() => {
    bookingHooks.listen({
      where: [['days', 'array-contains', format(day, 'dd-MM-yyyy')]],
      orderBy: [['startDate', 'asc']],
    })
    availabilityHooks.listen({
      where: [['dayDate', '==', startOfDay(day)]],
    })
    return () => {
      bookingHooks.unsubscribe()
      availabilityHooks.unsubscribe()
    }
  }, [day])
  
  if (!aircrafts) return <Loading />

  return (
    <Box component='table' sx={{
      tableLayout: 'fixed',
      textAlign: 'right',
      borderSpacing: 0,
      width: '100%',
      '& th': {
        fontSize: '11px',
        color: '#777',
      },
    }}>
      <thead>
        <tr>
          <Box component='th' sx={{ fontWeight: 'normal' }}>H</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>08</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>09</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>10</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>11</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>12</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>13</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>14</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>15</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>16</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>17</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>18</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>19</Box>
          <Box component='td' colSpan='4' sx={hoursStyle}>20</Box>
        </tr>
        <PseudoBorderLine />
      </thead>
      <tbody>
        {aircrafts.map(aircraft =>
          <PlanningRow
            key={aircraft.id}
            resource={aircraft}
            day={day}
            bookings={dbBookings?.filter(data => data.aircraftRef?.id === aircraft.id)}
            type='aircraft'
          />,
        )}
        {instructors?.map(([key, availabilities]) =>
          <PlanningRow
            key={key}
            resource={{ name: availabilities[0].user?.firstname + ' ' + availabilities[0].user?.lastname, ...availabilities[0].user }}
            day={day}
            bookings={dbBookings?.filter(data => data.instructorRef?.id === key)}
            type='instructor'
          />,
        )}
      </tbody>
    </Box>
  )
}

PlanningTable.propTypes = {
  day: PropTypes.object.isRequired,
}

export default PlanningTable
